import React, { useEffect, useRef, useState } from 'react'
import { useUserMedia } from "./use-user-media";
import {  Box,  CircularProgress} from '@mui/material';

const CAPTURE_OPTIONS = { audio: false, video: true }

export const CustomCamera = props => {
  const videoRef = useRef();
  const canvasRef = useRef();

  const [isVideoPlaying, setIsVideoPlaying] = useState(false);
  const [isCanvasEmpty, setIsCanvasEmpty] = useState(true)
  const [isChangeVideo, setIsChangeVideo] = useState(true);

  const [urlToblobImage, setUrlToblobImage] = useState(null);

  const mediaStream = useUserMedia(CAPTURE_OPTIONS);

  useEffect(() => {
    // console.log("videoRef.current: ", videoRef.current)
    if (mediaStream && videoRef.current && !videoRef.current.srcObject) {
      setIsChangeVideo(false)
      videoRef.current.srcObject = mediaStream;
      setIsVideoPlaying(true)
      handleClear()
    }
  }, [videoRef.current, mediaStream])

  useEffect(() => {
    if(props.CaptureInit == true){
      handleCapture()
    }else if(props.CaptureInit == false){      
      handleClear()
    }
  }, [props.CaptureInit])

  let handleCapture = () => {
    canvasRef.current.setAttribute(
      "width",
      videoRef.current.videoWidth
    )
    canvasRef.current.setAttribute(
      "height",
      videoRef.current.videoHeight
    )

    const context = canvasRef.current.getContext("2d");

    context.drawImage(
      videoRef.current,
      0,
      0,
      videoRef.current.videoWidth, videoRef.current.videoHeight
    );

    canvasRef.current.toBlob(blob => {
      setUrlToblobImage(blob)
      props.onCapture(blob)
    }, "image/jpeg", 1);
    setIsCanvasEmpty(false);
    // setIsFlashing(true);
  }

  let handleClear = () => {
    const context = canvasRef.current.getContext("2d");
    context.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
    setIsCanvasEmpty(true);
    setUrlToblobImage(null)
    props.onClear();
  }

  const Spinner = () => {
    return (
      <Box sx={{ display: "grid", placeContent: "center", height: 500 }}>
        <CircularProgress size={60} />
      </Box>
    );
  };

  return (
    <div style={{
      textAlign: 'center', display: 'flex',
      alignItems: 'center', flexDirection: 'column'
    }}>
      {/* {console.log("isChangeVideo: ", isChangeVideo)} */}
      {isChangeVideo === true ? <Box>
        <Spinner />
      </Box> : null}
      <video
        ref={videoRef}
        autoPlay={true}
        muted={true}
        width="100%"
        height="100%"
        hidden={!isCanvasEmpty}
      />
      <canvas
        ref={canvasRef}
        width={400}
        height={400}
        hidden={true}
      />

      {urlToblobImage ? <img
        width="80%"
        height="100%"
        src={urlToblobImage && URL.createObjectURL(urlToblobImage)}
        alt="experiment" /> : null}
    </div>
  );
}

